
// react-router-dom components
import { Link, useNavigate } from "react-router-dom";

// @mui material components
import Card from "@mui/material/Card";
import Checkbox from "@mui/material/Checkbox";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
// Authentication layout components
import CoverLayout from "layouts/authentication/components/CoverLayout";
import bgImage from "assets/images/bg-sign-up-cover.jpeg";
import FramerFade from "../../../components/Animation/Fade";
import React, { useEffect, useState } from "react";
import {
  KeyboardArrowLeft,
  KeyboardArrowRight,
  Visibility,
  VisibilityOff
} from "@mui/icons-material";
import {
  Alert,
  Button,
  FormControl,
  FormControlLabel,
  FormHelperText, FormLabel,
  InputAdornment, ListItemButton,
  MobileStepper, Radio,
  RadioGroup, Select, useTheme
} from "@mui/material";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import YupPassword from 'yup-password';
YupPassword(yup);
import {useDispatch, useSelector} from "react-redux";
import {
    authRegister, checkUsername,
    getEmailCode,
    getEmailCodeVerify,
    getVerificationCode,
    onErrorAlert,
    onSuccessAlert
} from "../../../actions";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Icon from "@mui/material/Icon";
import IconButton from "@mui/material/IconButton";
import isEmptyObject from "../../../utils/globalFunction";
import Autocomplete from "@mui/material/Autocomplete";
import MenuItem from "@mui/material/MenuItem";
import PlacesAutocomplete, {
  geocodeByAddress,
} from 'react-places-autocomplete';
import LocalStorage from "../../../utils/LocalStorage";
import { noop } from "lodash";
import { useDebounce } from 'use-debounce';
import {carrier_List} from "../../../actions/outbounds/outboundsAction";
import {useTranslation} from "react-i18next";

const addressFilter = ['address']



function Cover() {
    const { t, i18n } = useTranslation();
    const style= {
        img:{
            width:'120px',
            height:'40px',
            position:'absolute',
            right:0,
            top:-10,
            border:'2px solid grey',
            cursor:'pointer'
        }
    }

    const schema = yup
        .object({
            email: yup.string().email().required(t('SignUpPage.Email is Required')),
            username:yup.string().matches(/^\S*$/, t('SignUpPage.No spaces allowed in username')).min(3,t('SignUpPage.Username must contain 3 or more characters')).required(t('SignUpPage.Username is Required')),
            idNumber:yup.string().required(t('SignUpPage.ID Number is required')).matches(/^\S*$/, t('SignUpPage.No spaces allowed in ID Number')).min(5,t('SignUpPage.Please Input Valid ID Number')),
            lastname:yup.string().matches(/^\S*$/, t('SignUpPage.No spaces allowed in last name')).required(t('SignUpPage.Last name is Required')).min(1,t('SignUpPage.Please Input Valid Name')),
            firstname:yup.string().matches(/^\S*$/, t('SignUpPage.No spaces allowed in first name')).required(t('SignUpPage.First name is Required')).min(1,t('SignUpPage.Please Input Valid Name')),
            companyName: yup.string().trim().min(2,t('SignUpPage.Company Name must contain 2 or more characters')).required(t('SignUpPage.Company Name is Required')),
            address1:yup.string().trim(),
            address2:yup.string().trim(),
            password:yup.string().min(
                6,
                t('SignUpPage.Password must contain 6 or more characters')
            ).matches(/^\S*$/, t('SignUpPage.No spaces allowed in password')).minLowercase(1, t('SignUpPage.Password must contain at least 1 lower case letter'))
                .minUppercase(1, t('SignUpPage.Password must contain at least 1 upper case letter'))
                .minNumbers(1, t('SignUpPage.Password must contain at least 1 number'))
                .required(t("Required")),
            confirmpassword:yup
                .string()
                .oneOf([yup.ref("password"), null], t('SignUpPage.Passwords must match'))
                .required(t("Required")),
        })
    const {register,trigger,reset,setError,handleSubmit,getValues, setValue,clearErrors,formState: { errors }} = useForm({
        resolver: yupResolver(schema),
        mode: "onChange"
    });


    const ID_TYPES = {
        PASSPORT:'PASSPORT',
        DRIVING_LICENCE:'DRIVING_LICENSE',
        CITIZEN_CARD:'CITIZEN_CARD',
        RESIDENT_CARD:'RESIDENT_ID_CARD'
    }
    const IDTYPE_ARRAY = [
        {id:1,value:ID_TYPES.PASSPORT,title:t('SignUpPage.Passport')},
        {id:2,value:ID_TYPES.DRIVING_LICENCE,title:t('SignUpPage.Driver’s License')},
        {id:3,value:ID_TYPES.CITIZEN_CARD,title:t('SignUpPage.Citizen Card')},
        {id:4,value:ID_TYPES.RESIDENT_CARD,title:t('SignUpPage.Resident Card')},
    ]
  const nav= useNavigate()
  const theme = useTheme()
  const [img, setImg] = useState('');
  const dispatch = useDispatch()
  const [activeStep, setActiveStep] = useState(0);
  const [code, setCode] = useState(Array(6).fill(''));
  const [showPassword, setShowPassword] = useState(false);
  const [showPasswordConfirmation, setShowPasswordConfirmation] = useState(false);
  const [accountType,setAccountType] = useState('ENTERPRISE');
  const [idType,setIdType] = useState({id:1,value:ID_TYPES.PASSPORT,title:t('SignUpPage.Passport')})
  const [country,setCountry] = useState('1')
  const darkMode = useSelector(state => state?.common?.darkMode)
  const languageSelect = useSelector(state => state?.common?.language)
  const verification = useSelector(state => state?.auth?.verification)
  const [close,setClose] = useState(false)
  const [address,setAddress] = useState('')
  const [cityValue,setCityValue] = useState('')
  const [provinceValue,setProvinceValue] = useState('')
  const [postcodeValue,setPostcodeValue] = useState('')
  const [countryValue,setCountryValue] = useState('')
  const [phone,setPhone] = useState('')
  const [uuid, setUuid] = useState('');
  const [hoverSelect,setHoverSelect] = useState(false)
  const [usernameList,setUsernameList] = useState([])
  const [username,setUsername] = useState('')
  const [usernameLoading,setUsernameLoading] = useState(false)
  const [seconds, setSeconds] = useState(0);
  const [show, setShow] = useState(true);
  const [value] = useDebounce(username, 300);
  const [selectedCarrierList, setSelectedCarrierList] = useState([])

    useEffect(() => {
        if(!idType){
            setError('idType',{type:'idType',message:t('SignUpPage.ID Type is Required')})
        } else {
            clearErrors("idType")
        }
    }, [idType]);

    useEffect(() => {
        if(value!=='' && value){
            const user = value
            let formData = {}
            formData.username = user
            const checkUser = async () => {
                await dispatch(checkUsername(formData,onCheckName,onError))
            }
            checkUser().then()
        }
    }, [value]);

    useEffect(() => {
        const intervalId = setInterval(() => {
            if (seconds > 0) {
                setSeconds(seconds - 1);
            }
        }, 1000);
        if (seconds === 0) {
            setShow(false);
        } else {
            setShow(true)
        }

        return () => clearInterval(intervalId);
    }, [seconds]);

  useEffect(() => {
      if(activeStep === 0){
          reset()
          clearErrors()
      }

    if(activeStep === 1){
      setCode(Array(6).fill(''));

        setSeconds(99); // 重置秒数
    } else {

        setSeconds(0);

    }

    if(activeStep === 6) {
        const apiGet = async () => {
            await dispatch(getVerificationCode(noop,onError))
        }
        apiGet().then()
    }



  }, [activeStep])

    useEffect(() => {
        if(verification){
            setImg(`data:image/gif;base64,${verification?.img}`)
            setUuid(verification.uuid)
        }
    }, [verification]);


  const onError = async (msg, username) => {
      await dispatch(getVerificationCode())

      if (username) {
          setUsernameList([...usernameList, username])
          setActiveStep(2)
          setError('username', {type: 'errorName', message: t(`${t('SignUpPage.Username')} ${username} ${t('SignUpPage.already exists')}`)})
          dispatch(onErrorAlert(t(`${t('SignUpPage.Username')} ${username} ${t('SignUpPage.already exists')}`)))
      } else {
          dispatch(onErrorAlert(t(msg)))
      }
  }

  const onEmailSuccess = () => {
    setActiveStep(process.env.REACT_APP_VERIFIED_EMAIL === 'true' ? 1 : 2)
  }

  const onEmailResendSuccess =() => {
    dispatch(onSuccessAlert(t('resend verification code successfully')))
      setSeconds(99);
  }

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const onCheckName = (data) => {

      if(!data){
          setError('username',{type:'errorName',message:t(`${t('SignUpPage.Username')} ${username} ${t('SignUpPage.already exists')}`)})}
       else {
          if(errors.username && errors.username.type === 'errorName'){
              clearErrors('username',{type:'errorName'})
          }

      }
  }

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };
  const handleVerifyEmail = async () => {
    if (!errors.email && getValues('email')!=='') {
      const email = getValues('email')
      await dispatch(getEmailCode(email,onEmailSuccess,onError))
      // onEmailSuccess
    }
  }

  const handleIdNumber = () => {
      let error = false
      if(idType === null ){
          dispatch(onErrorAlert(t('SignUpPage.ID Type is Required')))
          error = true
          setError('idType',{type:'idType',message:t('SignUpPage.ID Type is Required')})
      }

      trigger(['idNumber','idType']).then(r => {
          if (r && !error ) {
              setActiveStep(4)
          }
      })

  }

  const handleBasicInfo = () => {
    const phoneNum = country+phone;
    const pattern = /^(\+?86)?1[3-9]\d{9}$/;
    if(!pattern.test(phoneNum) && phone!==''){
        setError('phone',{message:t('SignUpPage.Invalid phone number')})
    } else {
       clearErrors('phone')
    }

    trigger(['firstname','lastname','companyName'])

      if (!errors.lastname && getValues('lastname') !== '' && !errors.firstname && getValues('firstname') !== '' && !errors.phone && !errors.companyName && getValues('companyName') !== '') {
          // const axiosPost = async () => {
          //     await dispatch(carrier_List(noop, noop))
          // }
          // axiosPost().then()
          setActiveStep(5)
      }
  }
  // const handleCarrier = (list) => {
  //     setSelectedCarrierList(list)
  //     setActiveStep(6)
  // }
  //
  //   const handleCarrierBackward = (list) => {
  //       setSelectedCarrierList(list)
  //       setActiveStep(4)
  //   }



  const handleResendVerifyEmail = async () => {
    if (!errors.email && getValues('email')!=='' ) {
      const email = getValues('email')
      await dispatch(getEmailCode(email,onEmailResendSuccess,onError))
    }
  }

  function onEmailCodeSuccess() {
    setActiveStep(2)
  }

    const handleVerifyEmailCode = async () => {
        submitCode();
    }
    
    const submitCode = async () => {
        const formData = {};
        const verificationCode = code.join('');
        if(verificationCode!==''){
            formData.emailAddress = getValues('email')
            formData.emailCode = verificationCode
            await dispatch(getEmailCodeVerify(formData,onEmailCodeSuccess,onError))
        }
    };

    const onRegisterSuccess = (msg) =>{

        dispatch(onSuccessAlert(t(msg)))
        nav('/authentication/sign-in')
    }
    const handleMouseEnter = (index) => {
        setHoverSelect(index);
    };

    const handleMouseLeave = () => {
        setHoverSelect(-1);
    };

  const onSubmit = async (data) => {

      if(address.trim() ===''){
          return setError("address1",{ type: "address1", message: t('CustomerPage.Address is required') })
      }
      if(cityValue.trim() === ''){
          return setError("city",{ type: "city", message: t('CustomerPage.City is required') })
      }

      if(provinceValue.trim() === ''){
          return setError("province",{ type: "province", message: t('CustomerPage.Province is required') })
      }

      if(postcodeValue.trim() === ''){
          return setError("postcode",{ type: "postcode", message: t('CustomerPage.Postal Code is required') })
      }

      if(countryValue.trim() === ''){
          return setError("country",{ type: "country", message: t('CustomerPage.Country is required') })
      }

      let formData = {}
      formData.username = data.username
      formData.password = data.password
      formData.code = data.code
      formData.uuid = uuid
      //user info
      formData.userInfo = {}
      formData.userInfo.username = data?.username
      formData.userInfo.password = data?.password
      formData.userInfo.confirmPassword = data?.confirmpassword
      formData.userInfo.accountType = accountType
      formData.userInfo.oldUserFlag = 'N'
      formData.userInfo.code = data?.code
      formData.userInfo.uuid = uuid
      formData.userInfo.firstName = data?.firstname.trim()
      formData.userInfo.lastName = data?.lastname.trim()
      formData.userInfo.email = data?.email.trim()
      formData.userInfo.idType = idType?.value
      formData.userInfo.idNumber = data?.idNumber
      formData.userInfo.address1 = address.trim()
      formData.userInfo.address2 = data?.address2.trim()
      formData.userInfo.province = provinceValue.trim()
      formData.userInfo.country = countryValue.trim()
      formData.userInfo.city = cityValue.trim()
      formData.userInfo.postcode = postcodeValue.trim()
      formData.userInfo.companyName = data?.companyName.trim()
      // formData.userInfo.carrierList = selectedCarrierList

      if(phone!=='') {
          formData.userInfo.phone = country + phone
      }

      await dispatch(authRegister(formData, onRegisterSuccess, onError))
  }

    const handleChange = (e, index) => {
        const value = e.target.value;
        if (value.length <= 1) {
            const newCode = [...code];
            newCode[index] = value;
            setCode(newCode);
            if (value && index < 5) {
                document.getElementById(`code-${index + 1}`).focus();
            }
        }
    };

    const handlePaste = (e) => {
        const pasteData = e.clipboardData.getData('text').slice(0, 6);
        const newCode = pasteData.split('');
        while (newCode.length < 6) {
            newCode.push('');
        }
        setCode(newCode);
        
        const lastFilledIndex = newCode.findIndex((char, i) => char === '' || i === newCode.length - 1);
        document.getElementById(`code-${lastFilledIndex}`).focus();
    };
    
    const handleKeyDown = (e, index) => {
        if (e.key === "Backspace" && index > 0 && !code[index]) {
            document.getElementById(`code-${index - 1}`).focus();
        } else if (e.key === "Enter") {
            submitCode();
        }
    };


  const handleSelect = async address => {
    const results = await geocodeByAddress(address)
    let address1 = "";
    let postcode = "";
    let city = '';
    let state = '';
    let country = '';
    for(const component of results[0].address_components){
      const componentType = component.types[0];

      switch (componentType) {
        case "street_number": {
          address1 = `${component.long_name} ${address1}`;
          break;
        }

        case "route": {
          address1 += component.short_name;
          break;
        }

        case "postal_code": {
          postcode = `${component.long_name}${postcode}`;
          break;
        }

        case "postal_code_suffix": {
          postcode = `${postcode}-${component.long_name}`;
          break;
        }

        case "locality":
          city =
            component.long_name;
          break;

        case "administrative_area_level_1": {
          state =
              component.short_name;
          break;
        }

        case "country":
          country =
            component.short_name.toLowerCase();
          break;
      }
    }
    setAddress(address1)
    setCityValue(city)
    setProvinceValue(state)
    setCountryValue(country)
    setPostcodeValue(postcode)
    document.getElementById('address2').focus()
  };


  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const handleClickShowPasswordConfirmation = () => setShowPasswordConfirmation((show) => !show);


  const handleCredential = () => {
      const checkUser = async () => {
          await dispatch(checkUsername({username:getValues('username')},onCheckName,onError))
      }
      checkUser().then()
      let error = false


      if(getValues('password').trim() !== getValues('confirmpassword').trim()){
          setError('confirmpassword',{message:t('SignUpPage.Passwords must match')})
          error = true
      }
      if(errors.username || errors.password || errors.confirmpassword){
          error = true
      }



      trigger(['username','password','confirmpassword']).then(r => {
          if (r && !error) {
              setActiveStep(3)
          }
      })



  }

  function handleIdType(event,v) {
      setIdType(v)
  }

    return (
    <CoverLayout image={bgImage}>

        <Card>
          <MDBox
              variant="gradient"
              bgColor="info"
              borderRadius="lg"
              coloredShadow="success"
              mx={2}
              mt={-3}
              p={3}
              mb={1}
              textAlign="center"
          >
            <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
                {t('SignUpPage.Register')}
            </MDTypography>
            <MDTypography display="block" variant="button" color="white" my={1}>
                {t('SignUpPage.Enter your information to register')}
            </MDTypography>
          </MDBox>
          <MDBox pt={4} pb={2} px={3}>
            <MDBox component="form" role="form" onSubmit={handleSubmit(onSubmit)}>
              <FramerFade isActive={activeStep===0} delay={0}>
                <MDBox mb={2}>
                  <FormControl
                      error = {!!errors.email}
                      fullWidth
                      required
                      focused = {true}
                  >
                    <MDInput
                        type="email"
                        label={t('LegacySignUpPage.Email')}
                        variant="standard"
                        fullWidth
                        required
                        {...register("email")}
                        error={!!errors?.email}
                    />
                    <FormHelperText sx={{fontWeight:'medium'}}>{errors?.email?.message}</FormHelperText>
                  </FormControl>

                </MDBox>
                <MDBox mt={2}>
                  <MDButton variant="gradient" color="info" fullWidth onClick={handleVerifyEmail}>
                      {t('Continue')}
                  </MDButton>
                </MDBox>
              </FramerFade>
              <FramerFade isActive={activeStep===1} delay={0}>
                <Grid textAlign='center'><Icon style={darkMode?{color:'white'}:{color:'text'}}  fontSize={'large'}>lock</Icon></Grid>
                <Typography variant={'h5'} align="center">{t('ForgotPasswordPage.Enter your verification Code')}</Typography>
                <MDTypography align="center" display="block" variant="button"  my={1}>
                    {`${t('ForgotPasswordPage.We sent a verification code to')} ${getValues('email')}`}
                </MDTypography>
                <MDBox component="form" sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
                                    <MDBox sx={{ display: 'flex', gap: 1 }} onPaste={handlePaste}>
                                        {code.map((digit, index) => (
                                            <TextField
                                                key={index}
                                                id={`code-${index}`}
                                                value={digit}
                                                onChange={(e) => handleChange(e, index)}
                                                onKeyDown={(e) => handleKeyDown(e, index)}
                                                InputProps={{ maxLength: 1, style: { textAlign: 'center' } }}
                                                autoFocus={index === 0}
                                                sx={{
                                                    width: '40px', height: '20px', '& .MuiOutlinedInput-input': {
                                                        '&::-webkit-outer-spin-button, &::-webkit-inner-spin-button': {
                                                            '-webkit-appearance': 'none',
                                                        }
                                                    }
                                                }}
                                            />
                                        ))}
                                    </MDBox>
                                </MDBox>
                  <MDBox mt={4} display = "flex" alignItems="center" justifyContent = "start">
                  <MDTypography display="block" variant="button"  >
                      {t(`ForgotPasswordPage.Haven't receive a code?`)}
                  </MDTypography>
                  <Button sx={{padding:1}} onClick={handleResendVerifyEmail} disabled={show}>{t('Resend')}</Button>
                  <MDTypography display="block" variant="button" >
                    {show && `${seconds}s`}
                  </MDTypography>
                </MDBox>

                <MDBox mt={2}>
                  <MDButton variant="gradient" color="info" fullWidth onClick={handleVerifyEmailCode}>
                      {t('Verify')}
                  </MDButton>
                </MDBox>

              </FramerFade>
              <FramerFade isActive={activeStep===2} delay={0}>
                <MDBox mt={-2} textAlign='center'><Icon style={darkMode?{color:'white'}:{color:'text'}}  fontSize={'large'}>vpn_key</Icon></MDBox>
                <Typography variant={'h5'} align="center">{t('SignUpPage.Credential Info')}</Typography>
                <MDBox mt={2}>
                  <MDTypography variant={'h6'} sx={{marginRight: '20px'}}>{t('SignUpPage.Business Type')}</MDTypography>
                  <RadioGroup
                    name="accounttype"
                    value={accountType}
                    onChange={(e) => setAccountType(e.target.value)}
                    row={true}
                  >
                    <FormControlLabel value="ENTERPRISE" control={<Radio/>}
                                      label="B2B"/>
                    <FormControlLabel value="INDIVIDUAL" control={<Radio/>} label="B2C & B2B"/>
                  </RadioGroup>
                </MDBox>

                <MDBox mb={2}>
                  <FormControl
                    error = {!!errors.username}
                    fullWidth
                    required
                    focused = {true}
                  >
                    <MDInput
                      type="text"
                      label={t("SignInPage.Username")}
                      variant="standard"
                      fullWidth
                      required
                      {...register("username")}
                      error={!!errors?.username}
                      onChange={(e)=>setUsername(e.target.value)}
                      value={username}
                    />
                    <FormHelperText sx={{fontWeight:'medium'}}>{errors?.username?.message}</FormHelperText>

                  </FormControl>
                </MDBox>
                <MDBox mb={1}>
                  <FormControl
                    error = {!!errors.password}
                    fullWidth
                    required
                    focused = {true}
                  >
                    <MDInput
                      type={showPassword?'text':'password'}
                      label={t("SignInPage.Password")}
                      variant="standard"
                      fullWidth
                      required
                      {...register("password")}
                      InputProps={{
                        endAdornment:
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="toggle password visibility"
                              onClick={handleClickShowPassword}
                              edge="end"
                            >
                              {showPassword ? <VisibilityOff color={darkMode?'white':'info.main'} /> : <Visibility color={darkMode?'white':'info.main'} />}
                            </IconButton>
                          </InputAdornment>

                      }}
                    />
                    <FormHelperText sx={{fontWeight:'medium'}}>{errors?.password?.message}</FormHelperText>
                    <MDTypography variant={'caption'} mt={1} >{t('ForgotPasswordPage.At least 6 characters')}</MDTypography>
                    <MDTypography variant={'caption'}>{t('ForgotPasswordPage.Have at least one uppercase')}</MDTypography>
                    <MDTypography variant={'caption'}>{t('ForgotPasswordPage.Have at least one lowercase')}</MDTypography>
                    <MDTypography variant={'caption'}>{t('ForgotPasswordPage.Have at least one number')}</MDTypography>
                  </FormControl>
                </MDBox>
                <MDBox mb={2}>
                  <FormControl
                    error = {!!errors.confirmpassword}
                    fullWidth
                    required
                  >
                    <MDInput
                      type={showPasswordConfirmation?'text':'password'}
                      label={t('ForgotPasswordPage.New Password Confirmation')}
                      variant="standard"
                      fullWidth
                      required
                      {...register("confirmpassword")}
                      InputProps={{
                        endAdornment:
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="toggle password visibility"
                              onClick={handleClickShowPasswordConfirmation}
                              edge="end"
                            >
                              {showPasswordConfirmation ? <VisibilityOff color={darkMode?'white':'info.main'} /> : <Visibility color={darkMode?'white':'info.main'} />}
                            </IconButton>
                          </InputAdornment>

                      }}
                    />
                    <FormHelperText sx={{fontWeight:'medium'}}>{errors?.confirmpassword?.message}</FormHelperText>
                  </FormControl>
                </MDBox>
                <MDBox mt={2}>
                  <MDButton variant="gradient" color="info" fullWidth onClick={handleCredential}>
                      {t('Continue')}
                  </MDButton>
                </MDBox>
              </FramerFade>
              <FramerFade isActive={activeStep===3}>
                <MDBox mb={2}>
                  <Grid textAlign='center'><Icon style={darkMode?{color:'white'}:{color:'text'}} fontSize={'large'}>fingerprinter</Icon></Grid>
                  <MDTypography mb={2} variant={'h5'} align="center">{t('SignUpPage.Choose your ID Type')}</MDTypography>
                    <FormControl
                        error = {!!errors.idType}
                        fullWidth
                        required
                    ><Autocomplete
                    options={IDTYPE_ARRAY}
                    getOptionLabel={(option) => option.title}
                    isOptionEqualToValue={(option, value) => option?.id === value?.id}
                    value={idType}
                    onChange={handleIdType}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="standard"
                        label= {t("SignUpPage.ID Type")}
                        required={true}
                      />
                    )}
                    />
                        <FormHelperText sx={{fontWeight:'medium'}}>{errors?.idType?.message}</FormHelperText>

                    </FormControl>
                </MDBox>
                <MDBox mb={2}>
                  <FormControl
                    error = {!!errors.idNumber}
                    fullWidth
                    required
                    focused = {true}
                  >
                    <MDInput
                      type="text"
                      label={idType?.title?`${idType?.title} #`:''}
                      variant="standard"
                      fullWidth
                      required
                      {...register("idNumber")}
                      error={!!errors?.idNumber}
                    />
                    <FormHelperText sx={{fontWeight:'medium'}}>{errors?.idNumber?.message}</FormHelperText>

                  </FormControl>
                </MDBox>
                <MDBox mt={2}>
                    <Grid container spacing={3}>
                        <Grid item xs={12} md={6} lg={6}>
                            <MDButton variant="outlined" color="info" fullWidth onClick={handleBack}>
                                {t('Back')}
                            </MDButton>
                        </Grid>
                        <Grid item xs={12} md={6} lg={6}>
                            <MDButton variant="gradient" color="info" fullWidth onClick={handleIdNumber}>
                                {t('Continue')}
                            </MDButton>
                        </Grid>
                    </Grid>
                </MDBox>
              </FramerFade>
              <FramerFade isActive={activeStep===4} delay={0}>
                <Grid textAlign='center'><Icon style={darkMode?{color:'white'}:{color:'text'}}  fontSize={'large'}>account_circle</Icon></Grid>
                <MDTypography variant={'h5'} align="center">{t('SignUpPage.Basic Info')}</MDTypography>
                  <MDBox mb={2}>
                      <FormControl
                          error = {!!errors.companyName}
                          fullWidth
                          required
                          focused = {true}
                      >
                          <MDInput
                              type="text"
                              label={t('SignUpPage.Company Name')}
                              variant="standard"
                              fullWidth
                              required
                              {...register("companyName")}
                              error={!!errors?.companyName}
                          />
                          <FormHelperText sx={{fontWeight:'medium'}}>{errors?.companyName?.message}</FormHelperText>

                      </FormControl>
                  </MDBox>
                <MDBox mb={2}>
                  <FormControl
                    error = {!!errors.firstname}
                    fullWidth
                    required
                    focused = {true}
                  >
                    <MDInput
                      type="text"
                      label={t("SignUpPage.First Name")}
                      variant="standard"
                      fullWidth
                      required
                      {...register("firstname")}
                      error={!!errors?.firstname}
                    />
                    <FormHelperText sx={{fontWeight:'medium'}}>{errors?.firstname?.message}</FormHelperText>

                  </FormControl>
                </MDBox>
                <MDBox mb={2}>
                  <FormControl
                    error = {!!errors.lastname}
                    fullWidth
                    required
                    focused = {true}
                  >
                    <MDInput
                      type="text"
                      label={t("SignUpPage.Last Name")}
                      variant="standard"
                      fullWidth
                      required
                      {...register("lastname")}
                      error={!!errors?.lastname}
                    />
                    <FormHelperText sx={{fontWeight:'medium'}}>{errors?.lastname?.message}</FormHelperText>

                  </FormControl>
                </MDBox>
                <MDBox mb={2}>
                  <FormControl
                      error = {!!errors.phone}
                      fullWidth
                      required
                      focused = {true}
                  >
                    <MDInput
                        type="text"
                        label={t("SignUpPage.Telephone Number")}
                        variant="standard"
                        fullWidth
                        error = {!!errors.phone}
                        value={phone}
                        onChange = {event=> {
                          setValue('phone',country+event.target.value)
                          setPhone(event.target.value)
                        }}
                        InputProps={{
                          startAdornment:
                              <InputAdornment position="start"
                                              sx={{
                                                    color: 'red'}}
                              >
                                <FormControl variant="standard" >
                                  <Select
                                      value={country}
                                      onChange={(event)=>{setCountry(event.target.value)}}
                                      style={darkMode?{color:'white'}:{color:'primary'}}
                                  >
                                    <MenuItem value={'1'}>+1</MenuItem>
                                    <MenuItem value={'86'}>+86</MenuItem>
                                  </Select>
                                </FormControl>
                              </InputAdornment>
                        }}
                    />
                    <FormHelperText sx={{fontWeight:'medium'}}>{errors?.phone?.message}</FormHelperText>
                  </FormControl>
                </MDBox>
                <MDBox mt={2}>
                    <Grid container spacing={3}>
                        <Grid item xs={12} md={6} lg={6}>
                            <MDButton variant="outlined" color="info" fullWidth onClick={handleBack}>
                                {t('Back')}
                            </MDButton>
                        </Grid>
                        <Grid item xs={12} md={6} lg={6}>
                            <MDButton variant="gradient" color="info" fullWidth onClick={handleBasicInfo}>
                                {t('Continue')}
                            </MDButton>
                        </Grid>
                    </Grid>
                </MDBox>
              </FramerFade>
                {/*<FramerFade isActive={activeStep===5} delay={0}>*/}
                {/*    <UserCarrierEdit open={true} parent={"signUp"} signUpHandler={handleCarrier} signUpList={selectedCarrierList} signUpBackward={handleCarrierBackward}/>*/}
                {/*</FramerFade>*/}

              <FramerFade isActive={activeStep===5} delay={0}>
                <Grid textAlign='center'><Icon style={darkMode?{color:'white'}:{color:'text'}}  fontSize={'large'}>account_circle</Icon></Grid>
                <MDTypography variant={'h5'} align="center">{t('SignUpPage.Address Info')}</MDTypography>
                <MDBox mt={2} mb={2} sx={close?{display:'none'}:{}}>
                  <Alert  severity="warning" onClose={() => setClose(true)}>
                      {t('SignUpPage.If you are registering as a business, please fill in the address of the business registered to calculate the relevant taxes.')}
                  </Alert>
                </MDBox>
                <MDBox mb={2}>
                  <PlacesAutocomplete
                    value={address}
                    onChange={setAddress}
                    onSelect={handleSelect}
                    searchOptions={{
                      language:languageSelect ==='zh'?'zh':'en',
                      types: addressFilter,
                      fields:["address_components"],
                      componentRestrictions: {
                        country: ['us','ca','cn'],
                      },
                    }}
                    debounce={200}
                  >
                    {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                        <FormControl
                          error = {!!errors.address1}
                          fullWidth
                          required
                          focused = {true}
                        >
                          <MDInput
                            {...getInputProps()}
                            type="text"
                            label={t("SignUpPage.Address 1")}
                            inputProps={{
                                autocomplete: "new-password",
                            }}
                            variant="standard"
                            fullWidth
                            required
                          />
                          <FormHelperText sx={{fontWeight:'medium'}}>{errors?.address1?.message}</FormHelperText>
                          <div>
                            {loading && <div style={{fontSize:'small'}}>Loading...</div>}
                            {suggestions.map((suggestion,index )=> (
                              <div {...getSuggestionItemProps(suggestion)}>
                                <span
                                    onMouseEnter={() => handleMouseEnter(index)}
                                    onMouseLeave={handleMouseLeave}
                                    style={{fontSize:'small',cursor:'pointer',fontStyle: index === hoverSelect?'italic' : 'normal'}}
                                >{suggestion.description}</span>
                              </div>
                            ))}
                          </div>
                        </FormControl>

                      )

                    }

                  </PlacesAutocomplete>

                </MDBox>
                <MDBox mb={2}>
                  <FormControl
                      error = {!!errors.address2}
                      fullWidth
                      focused = {true}
                  >
                    <MDInput
                        type="text"
                        id={'address2'}
                        inputProps={{
                            autocomplete: "new-password",
                        }}
                        label={t("SignUpPage.Apartment, unit, suite, or floor #")}
                        variant="standard"
                        fullWidth
                        {...register("address2")}
                        error={!!errors?.address2}
                    />
                    <FormHelperText sx={{fontWeight:'medium'}}>{errors?.address2?.message}</FormHelperText>
                  </FormControl>
                </MDBox>
                <MDBox mb={2}>
                  <FormControl
                      error = {!!errors.city}
                      fullWidth
                      required
                      focused = {true}
                  >
                    <MDInput
                        required
                        type="text"
                        label={t('SignUpPage.City')}
                        inputProps={{
                            autocomplete: "new-password",
                        }}
                        variant='standard'
                        fullWidth
                        name='city'
                        value={cityValue}
                        onChange={(event)=>setCityValue(event.target.value)}
                        error={!!errors?.city}
                    />
                    <FormHelperText sx={{fontWeight:'medium'}}>{errors?.city?.message}</FormHelperText>
                  </FormControl>
                </MDBox>

                <MDBox mb={2}>
                  <FormControl
                      error = {!!errors.province}
                      fullWidth
                      required

                  >
                    <MDInput
                        required
                        type="text"
                        label={t('SignUpPage.State/Province')}
                        variant='standard'
                        inputProps={{
                            autocomplete: "new-password",
                        }}
                        fullWidth
                        name='province'
                        value={provinceValue}
                        onChange={(event)=>setProvinceValue(event.target.value)}
                        error={!!errors?.province}
                    />
                    <FormHelperText sx={{fontWeight:'medium'}}>{errors?.province?.message}</FormHelperText>
                  </FormControl>
                </MDBox>
                <Grid container mb={2} display="flex" xs={12} spacing={2}>
                  <Grid item xs={6} mb={2}>
                    <FormControl
                      error = {!!errors.postcode}
                      fullWidth
                      required
                    >
                      <MDInput
                        required
                        type="text"
                        label={t('SignUpPage.Postal Code')}
                        inputProps={{
                            autocomplete: "new-password",
                        }}
                        variant='standard'
                        fullWidth
                        name='postcode'
                        value={postcodeValue}
                        onChange={(event)=>setPostcodeValue(event.target.value)}
                        error={!!errors?.postcode}
                      />
                      <FormHelperText sx={{fontWeight:'medium'}}>{errors?.postcode?.message}</FormHelperText>
                    </FormControl>
                  </Grid>
                  <Grid item xs={6} mb={2}>
                    <FormControl
                      error = {!!errors.country}
                      fullWidth
                      required
                    >
                      <MDInput
                        required
                        type="text"
                        label={t('SignUpPage.Country')}
                        disabled={true}
                        inputProps={{
                            autocomplete: "new-password",
                        }}
                        variant='standard'
                        fullWidth
                        name='country'
                        value={countryValue}
                        onChange={(event)=>setCountryValue(event.target.value)}
                        error={!!errors?.country}
                      />
                      <FormHelperText sx={{fontWeight:'medium'}}>{errors?.country?.message}</FormHelperText>
                    </FormControl>
                  </Grid>
                </Grid>

                  <MDBox sx={{position:'relative'}}>
                      <FormControl
                          error = {!!errors.code}
                          fullWidth
                          required
                      >
                          <MDInput
                              label={t('SignInPage.Verification')}
                              {...register("code")}
                              variant='standard'
                              fullWidth
                              required
                              error={!!errors.code}
                              InputProps={{
                                  endAdornment:  <InputAdornment position="end" >
                                      <img
                                          src={img}
                                          alt={'verification code'}
                                          style={style.img}
                                          onClick={async () => await dispatch(getVerificationCode())}
                                          loading="lazy"
                                      />
                                  </InputAdornment>
                              }}
                          />
                          <FormHelperText sx={{fontWeight:'medium'}}>{errors?.code?.message}</FormHelperText>
                      </FormControl>
                  </MDBox>

                <MDBox mt={2}>
                    <Grid container spacing={3}>
                        <Grid item xs={12} md={6} lg={6}>
                            <MDButton variant="outlined" color="info" fullWidth onClick={handleBack}>
                                {t('Back')}
                            </MDButton>
                        </Grid>
                        <Grid item xs={12} md={6} lg={6}>
                            <MDButton variant="gradient" color="info" fullWidth type={'submit'}>
                                {t('Submit')}
                            </MDButton>
                        </Grid>
                    </Grid>
                </MDBox>

              </FramerFade>
              <MDBox mt={1} mb={2} textAlign="center">
                <MDTypography variant="button" color="text">
                    {t('LegacySignUpPage.Already have an account')+"? "}
                  <MDTypography
                    component={Link}
                    to="/authentication/sign-in"
                    variant="button"
                    color="info"
                    fontWeight="medium"
                    textGradient
                  >
                      {t('SignInPage.Sign In')}
                  </MDTypography>
                </MDTypography>
              </MDBox>
              <MobileStepper
                  variant="dots"
                  steps={6}
                  position="static"
                  activeStep={activeStep}
                  sx={{
                      display:'none',
                    flexGrow: 1
                  }}
                  nextButton={
                    <Button size="small" onClick={handleNext} disabled={activeStep === 6}>
                      Next
                      {
                          <KeyboardArrowRight />
                      }
                    </Button>
                  }
                  backButton={
                    <Button size="small" onClick={handleBack} disabled={activeStep === 0}>
                      {
                          <KeyboardArrowLeft />
                       }
                      Back
                    </Button>
                  }
              />
            </MDBox>
          </MDBox>
        </Card>

    </CoverLayout>
  );
}

export default Cover;
